import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const ComplianceTermsSectionContainer = styled(Box)(({ theme }) => {
  const breakpoints = theme.breakpoints;
  const spacing = theme.spacing;

  return {
    [breakpoints.up('xs')]: {
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
    },
    [breakpoints.up('sm')]: {
      paddingLeft: spacing(5),
      paddingRight: spacing(5),
    },
    [breakpoints.up('xl')]: {
      width: '100%',
      maxWidth: '900px',
      margin: '0px auto',
      paddingRight: spacing(10),
      paddingLeft: spacing(10),
    },
  };
});

export const ComplianceTermsSectionHeader = styled(Box)(({ theme }) => {
  const breakpoints = theme.breakpoints;
  const spacing = theme.spacing;
  const maxTabletSize = breakpoints.values.md + 1;

  return {
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('xs')]: {
      marginBottom: spacing(4),
    },
    [breakpoints.up('sm')]: {
      marginBottom: spacing(5),
    },
    [breakpoints.up(maxTabletSize)]: {
      rowGap: spacing(1),
    },
  };
});

export const ComplianceTermsSectionTitle = styled(Typography)(({ theme }) => {
  const breakpoints = theme.breakpoints;

  return {
    [breakpoints.down('lg')]: {
      lineHeight: '46px',
    },
    [breakpoints.down('sm')]: {
      fontSize: '24px',
      lineHeight: '34px',
    },
  };
}) as typeof Typography;

export const ComplianceTermsSectionBody = styled(Box)(({ theme }) => {
  return {
    borderRadius: theme.spacing(1),
    border: '1px solid #080A2D4D',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('xs')]: {
      paddingLeft: theme.spacing(2.5),
      paddingRight: theme.spacing(2.5),
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    marginBottom: theme.spacing(4),
  };
});

export const ComplianceTermsSectionFooter = styled(Box)(({ theme }) => {
  const breakpoints = theme.breakpoints;
  const spacing = theme.spacing;

  return {
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('xs')]: {
      rowGap: spacing(4),
    },
    [breakpoints.up('sm')]: {
      rowGap: spacing(5),
    },
  };
});

export const LinkPolicyButton = styled(Button)(({ theme }) => {
  const breakpoints = theme.breakpoints;

  return {
    alignSelf: 'flex-end',
    [breakpoints.up('xs')]: {
      width: '100%',
    },
    [breakpoints.up('sm')]: {
      width: 'fit-content',
    },
  };
}) as typeof Button;

export const LegalCopyText = styled(Typography)(() => {
  return {
    fontSize: '12px',
    color: '#777777',
    lineHeight: '16px',
  };
}) as typeof Typography;
